import { createApi } from '@reduxjs/toolkit/query/react';
import apiBaseQuery from './axiosBaseQuery';
export const DASHBOARD_STATS = 'dashboardStatsApi';

export const dashboardStatsApi = createApi({
    reducerPath: DASHBOARD_STATS,
    baseQuery: apiBaseQuery,
    tagTypes: ['dashboard'],
    endpoints: (builder) => ({
        getDashboardStats: builder.query({
            query: ({ year }) => ({
                url: `/portfolio/dashboard-stats?year=${year}`
            }),
            providesTags: ['dashboard']
        }),

    })
});

export const {
    useGetDashboardStatsQuery
} = dashboardStatsApi;